import { useGameStore } from '../store/gameStore';
import { getTranslation } from '../utils/i18n';

export const useTranslation = () => {
  const language = useGameStore((state) => state.language);
  return getTranslation(language);
};
